module.exports = __webpack_public_path__ + "img/vote_medium.ba7732ea.svg";